import React, { Component } from "react";
import { connect } from "react-redux";
import LikePost from "./LikePost.jsx";
import ModalSupprimer from "./ModalSupprimer.jsx";
import ModalPost from "./ModalPost";
import {
  addPostCommunaute,
  getPostCommunaute,
  deletePost,
  chooseFavori,
  resetMediaAttachment,
} from "./Communaute.duck";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import ModalPostPrivate from "./ModalPostPrivate";
import CouplePost from "./CouplePost.jsx";
import { withTranslation } from 'react-i18next';

class Communaute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLikes: false,
      postDescription:
        "Quelques photos de la kermesse organisée à la crèche cette année, un plaisir pour petits et grands !",
      openModalPost: false,
      picsList: null,
      postId: "",
      items: [],
      hasMore: true,
      page: [],
      isLoading: true,
      scrollLoader: false,
      offset: 1,
      openModalDelete: false,
      idPost: null,
      favori: false,
      indeUrlFavori: null,
      postText: "",
      openModalPostPrivate: false,
      selectedPost: "",
      itemsArray: [],
    };
    this.openLikeModal = this.openLikeModal.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openModalPost = this.openModalPost.bind(this);
    this.closeModalPost = this.closeModalPost.bind(this);
    this.fetchMoreData = this.fetchMoreData.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.onCloseModaleSuppression = this.onCloseModaleSuppression.bind(this);
    this.onSubmitSuppression = this.onSubmitSuppression.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addFavori = this.addFavori.bind(this);
    this.openModalPostPrivate = this.openModalPostPrivate.bind(this);
    this.CloseModalPostPrivate = this.CloseModalPostPrivate.bind(this);
  }

  addFavori(file, key) {
    this.setState({
      favori: true,
      indeUrlFavori: key,
    });
    var filtered = this.props.dataPost.files.filter(function(
      value,
      index,
      arr
    ) {
      if (index !== key) {
        return value;
      }
    });
    this.props.chooseFavori(filtered, file);
  }
  onSubmitSuppression() {
    let tok = localStorage.getItem("token");
    let size = 20;

    const response = Service.deleteOne(
      `${API}api/creche/posts/${this.state.idPost}`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      const response2 = Service.get(
        `${API}api/creche/posts?offset=1&path-size=${size}`,
        { headers: { Authorization: `Bearer ${tok}` } }
      );
      response2.then((res2) => {
        let sortedItems = res2.data.page.elements;
        sortedItems = sortedItems.sort((a, b) =>
          moment(b.dateTime).diff(a.dateTime)
        );
        let itemsArray = [];
        sortedItems.forEach((item, index) => {
          if (index % 2 == 0) {
            let couplePost = [sortedItems[index]];
            if (sortedItems[index + 1] !== undefined) {
              couplePost.push(sortedItems[index + 1]);
            }
            itemsArray.push(couplePost);
          }
        });

        this.setState({
          itemsArray: itemsArray,
        });
      });
    });

    this.setState({ openModalDelete: false, idPost: null });
  }
  handleSubmit() {
    let tok = localStorage.getItem("token");
    const data = {
      coverId: this.props.dataPost.coverId,
      description: this.state.description,
      photosIds: this.props.dataPost.files,
      typePoste: this.props.dataPost.type,
      videoId: this.props.videoId,
    };
    const response = Service.post(`${API}api/creche/posts`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {});
    response.catch((err) => {});
    this.setState({
      openModalDelete: false,
      idPost: null,
      coverId: null,
      description: "",
      photosIds: [],
      videoId: null,
    });
  }
  onCloseModaleSuppression() {
    this.setState({ openModalDelete: false });
  }
  openModalDelete(idPost) {
    this.setState({ openModalDelete: true, idPost: idPost });
  }
  CloseModalPostPrivate = () => {
    this.setState({
      openModalPostPrivate: false,
      idPost: "",
      selectedPost: "",
    });
  };
  openModalPostPrivate(Post) {
    this.setState({
      openModalPostPrivate: true,
      selectedPost: Post,
      idPost: Post.id,
    });
  }
  fetchMoreData = () => {
    this.setState({
      scrollLoader: true,
    });
    if (
      this.state.items.length === this.props.dataPost.posts.page.totalElements
    ) {
      this.setState({ hasMore: false });
      return;
    } else {
      setTimeout(() => {
        let tok = localStorage.getItem("token");
        let offset = this.state.offset + 1;

        const response = Service.get(
          `${API}api/creche/posts?offset=${offset}&path-size=20`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          let sortedItems = this.state.items.concat(res.data.page.elements);

          sortedItems = sortedItems.sort((a, b) =>
            moment(b.dateTime).diff(a.dateTime)
          );
          let itemsArray = [];
          sortedItems.forEach((item, index) => {
            if (index % 2 == 0) {
              let couplePost = [sortedItems[index]];
              if (sortedItems[index + 1] !== undefined) {
                couplePost.push(sortedItems[index + 1]);
              }
              itemsArray.push(couplePost);
            }
          });
          this.setState({
            itemsArray: itemsArray,
            items: sortedItems,
            offset: offset,
            scrollLoader: false,
          });
        });
      }, 500);
    }
  };

  closeModalPost() {
    this.setState({ openModalPost: false, indeUrlFavori: null, favori: false });
    this.props.resetMediaAttachment();
  }
  openModalPost() {
    this.setState({ openModalPost: true });
  }
  handleChange(event) {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
  }

  onClose() {
    this.setState({
      showLikes: false,
    });
  }
  openLikeModal() {
    this.setState({
      showLikes: true,
    });
  }

  componentDidMount() {
    let tok = localStorage.getItem("token");
    this.props.getPostCommunaute(tok, 1);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.dataPost.posts !== this.props.dataPost.posts &&
      !_.isEmpty(this.props.dataPost.posts) &&
      !_.isEmpty(this.props.dataPost.posts.page)
    ) {
      let sortedItems = this.props.dataPost.posts.page.elements.sort((a, b) =>
        moment(b.dateTime).diff(a.dateTime)
      );
      let itemsArray = [];
      sortedItems.forEach((item, index) => {
        if (index % 2 == 0) {
          let couplePost = [sortedItems[index]];
          if (sortedItems[index + 1] !== undefined) {
            couplePost.push(sortedItems[index + 1]);
          }
          itemsArray.push(couplePost);
        }
      });
      this.setState({
        itemsArray: itemsArray,
        items: sortedItems,
        isLoading: false,
      });
    }
  }

  render() {
    const { t } = this.props;
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    let lienPhoto = !_.isEmpty(this.props.dataCompte)
      ? this.props.dataCompte.urlPhoto
      : "";
    var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      overflow: "hidden",
    });
    return (
      <div>
        {this.state.openModalPost ? (
          <ModalPost
            closeModalPost={this.closeModalPost}
            favori={this.state.favori}
            indeUrlFavori={this.state.indeUrlFavori}
            addFavori={this.addFavori}
            lienPhoto={lienPhoto}
          />
        ) : null}
        {this.state.isLoading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.eventsLoading}
            />
          </div>
        ) : (
          <div className="main-wrapper staff">
            <div className="banner p-0 d-flex align-items-center justify-content-center">
              <Link to="/" className="back-link">
                {t('common.back')}
              </Link>
              <div className="content">
                <h1>
                  {t('communaute.title')}
                  <br />
                  <small>{t('communaute.subtitle')}</small>
                </h1>
              </div>
            </div>
            <div className="publish-zone">
              <div className="row d-flex align-items-center justify-content-center">
                <div className="col-md-9">
                  <a href="#" data-toggle="modal" data-target="#modalAddMedia">
                    <div className="new-post d-flex align-items-start">
                      <div className="infos">
                        <div
                          className="avatar-fiche"
                          style={divStyle(lienPhoto)}
                        />
                      </div>
                      <div className="post-write">
                        <textarea
                          className="form-control"
                          onClick={this.openModalPost}
                          defaultValue={t('communaute.start_post')}
                        />
                        <div className="search-media btn-gradient">
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#modalAddMedia"
                            onClick={this.openModalPost}
                          >
                            <span>{t('communaute.add_media')}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            {this.state.items.length > 0 ? (
              <div className="list-posts">
                {this.state.showLikes ? (
                  <LikePost onClose={this.onClose} />
                ) : null}
                <div className="infinite-scroll-component__outerdiv">
                  <div
                    className="infinite-scroll-component "
                    style={{ height: "auto" }}
                  >
                    <InfiniteScroll
                      style={{ overflow: "none" }}
                      dataLength={this.state.items.length}
                      next={this.fetchMoreData}
                      hasMore={this.state.hasMore}
                      loader={
                        <div className="content p-0">
                          <DotLoader
                            size={100}
                            color={"#ff7d26"}
                            css={override}
                          />
                        </div>
                      }
                    >
                      {!_.isEmpty(this.state.itemsArray) &&
                        this.state.itemsArray.map((post, key) => (
                          <CouplePost
                            key={key}
                            post={post}
                            openModalDelete={this.openModalDelete}
                            openLikeModal={this.openLikeModal}
                            openModalPostPrivate={this.openModalPostPrivate}
                          />
                        ))}
                    </InfiniteScroll>
                  </div>
                </div>
              </div>
            ) : (
              <p style={{ textAlign: "center" }}>
                <b>{t('communaute.nothing_shared')}</b>
              </p>
            )}
            {this.state.openModalDelete ? (
              <ModalSupprimer
                onCloseModaleSuppression={this.onCloseModaleSuppression}
                onSubmitSuppression={this.onSubmitSuppression}
              />
            ) : (
              ""
            )}

            {this.state.openModalPostPrivate ? (
              <ModalPostPrivate
                selectedPost={this.state.selectedPost}
                CloseModalPostPrivate={this.CloseModalPostPrivate}
              />
            ) : (
              " "
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dataPost: state.Communaute.data,
  loading: state.Communaute.loading,
  dataCompte: state.compte.data,
});

export default connect(mapStateToProps, {
addPostCommunaute,
  getPostCommunaute,
  deletePost,
  chooseFavori,
  resetMediaAttachment,
})(withTranslation()(Communaute));
